import styled from 'styled-components';

export const ErrorWrapper = styled.div`
  display: flex;
  position: relative;
  z-index: 1;
  gap: 1rem;
  padding: 0.5rem 1rem;
  background: ${(props) => props.theme.color.errorDark};
  color: ${(props) => props.theme.color.contrast.errorDark};
  border-radius: ${(props) => props.theme.borderRadius.sm};
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ChatError = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;
